module.exports = __webpack_public_path__ + "static/media/component12.1e06a3da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/component12.png
// module id = 2416
// module chunks = 0